export const mapStatRecords = (record) => {

  record = {
    ...record,
    testsBillTodo: record.testsBillTodo.reduce((partialSum, a) => partialSum + a, 0),
    testsBillTodoAndCancelled: record.testsBillTodoAndCancelled.reduce((partialSum, a) => partialSum + a, 0),
    testsLateWithPartLab: record.testsLateWithPartLab.reduce((partialSum, a) => partialSum + a, 0),
    testsLateWithoutPartLab: record.testsLateWithoutPartLab.reduce((partialSum, a) => partialSum + a, 0)
  }

  Object.entries(record).forEach(([key, value]) => {
    record[key] = `${value}`;
  });

  return record;
};